import { Card } from '@/components/ui/card';
import { PageHeader } from '@/components/ui/page-header';
import { FcBullish, FcBusinessman, FcDebt, FcEngineering, FcFilledFilter, FcGlobe, FcOnlineSupport, FcOrganization, FcSupport } from "react-icons/fc";
import { Link } from 'react-router-dom';

const cadastros = [
  { to: '/cadastro/clientes', label: 'Clientes', desc: 'Tomadores das NFs', icon: FcBusinessman  },
  { to: '/cadastro/servicos', label: 'Serviços', desc: 'Serviços dos contratos', icon: FcSupport  },
  { to: '/cadastro/modalidades', label: 'Modalidades', desc: 'Modalidades de compra', icon: FcFilledFilter  },
  { to: '/cadastro/indices-reajuste', label: 'Índices de Reajuste', desc: 'IPCA, INPC, etc.', icon: FcBullish  },
  { to: '/cadastro/tributacoes', label: 'Tributação Nacional', desc: 'Códigos LC 116/2003', icon: FcDebt  },
  { to: '/cadastro/estados', label: 'Estados', desc: 'UFs', icon: FcGlobe  },
  { to: '/cadastro/municipios', label: 'Municípios', desc: 'IBGE', icon: FcOrganization  },
  { to: '/cadastro/usuarios', label: 'Usuários', desc: 'Acesso ao sistema', icon: FcOnlineSupport  },
  { to: '/cadastro/parametros', label: 'Parâmetros', desc: 'Alíquota padrão', icon: FcEngineering   },
]

export default function CadastroIndex() {
  return (
    <div className="flex flex-col h-full">
      <PageHeader title="Cadastros" subtitle="Cadastros auxiliares do sistema." />

      <div className="flex-1 overflow-auto p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cadastros.map(({ to, label, desc, icon: Icon }) => (
          <Link key={to} to={to}>
            <Card className="p-5 flex items-center gap-4 hover:border-primary hover:shadow-md transition-all">
              <div className="h-11 w-11 rounded-lg bg-accent flex items-center justify-center text-primary">
                <Icon className="h-6.5 w-6.5" />
              </div>
              <div>
                <div className="font-medium">{label}</div>
                <div className="text-sm text-muted-foreground">{desc}</div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
      </div>
    </div>
  )
}
